import { TextAlertComponent } from './text-alert/text-alert.component';
import { TitleAndContentModalComponent } from './title-and-content-modal/title-and-content-modal.component';

export const ModalRegular = {
  TEXT_ALERT: TextAlertComponent,
  TITLE_AND_CONTENT: TitleAndContentModalComponent,
};

export type ModalRegularType = keyof typeof ModalRegular;
